import { createContext, useContext, useMemo } from 'react';

interface AccordionItemContextType {
	itemKey: string,
}

type AccordionItemProviderProps = AccordionItemContextType & {
	children: React.ReactNode;
}

const AccordionItemContext = createContext<AccordionItemContextType>({
	itemKey: '',
});

export function AccordionItemProvider({ 
	itemKey, 
	children 
}: AccordionItemProviderProps) {
	const value = useMemo(() => ({
		itemKey,
	}), [itemKey]);

	return (
		<AccordionItemContext.Provider value={value}>
			{children}
		</AccordionItemContext.Provider>
	);
}

export const useAccordionItemContext = () => useContext(AccordionItemContext);